import { createContext, useContext, useState, useCallback } from "react";
import { LANGUAGES, DEFAULT_LANGUAGE_CODE } from "@/constants/languages";
import { toast } from "sonner";

const LanguageContext = createContext(null);

const STORAGE_KEY = "rkg-language";

export const LanguageProvider = ({ children }) => {
  const [languageCode, setLanguageCode] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || DEFAULT_LANGUAGE_CODE;
    } catch {
      return DEFAULT_LANGUAGE_CODE;
    }
  });

  const setLanguage = useCallback((code) => {
    setLanguageCode(code);
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch {}
    const lang = LANGUAGES.find((l) => l.code === code);
    if (code !== DEFAULT_LANGUAGE_CODE) {
      toast.info(`${lang?.label} translation coming soon`, {
        description: "The website is currently displayed in English.",
      });
    }
  }, []);

  const currentLanguage = LANGUAGES.find((l) => l.code === languageCode) || LANGUAGES[0];

  return (
    <LanguageContext.Provider value={{ currentLanguage, setLanguage, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
